// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* ===== MOBILE VIEWPORT SAFETY ===== */

html,
body {
  width: 100%;
  overflow-x: hidden;
}

.categoryLanding {
  width: 100%;
  max-width: 100%;
  background: #f5f7fb;
  overflow-x: hidden;
}


/* ===== PAGE GUTTERS ===== */


.cl-galleryMain {
  width: 95%;
  max-width: 420px;
  margin: 0 auto 16px;
}

.cl-galleryMainInner {
  position: relative;
  width: 100%;
  aspect-ratio: 4 / 3;
  border-radius: 16px;
  overflow: hidden;
  background: #e5e7eb;
}

.cl-galleryMainInner img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}


.cl-zipForm {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  width: 100%;
  margin-left: 13px;
}

.cl-zipInput {
  flex: 1;
  padding: 5px 12px;
    font-size: 15px;
  border-radius: 6px;
  border: none;
  width: 147px;
  
}

.cl-zipInput--manualEntry {
  flex: 0 0 200px;
  width: 200px;
  max-width: 100%;
}

.cl-zipButton {
  background: #ff9f1c;
  color: #111;
  font-weight: 600;
  border: none;
  padding: 10px 8px;
  border-radius: 6px;
  cursor: pointer;
  width: 118px;
}

.cl-zipSecondaryButton {
  background: rgba(255, 255, 255, 0.92);
  color: #153a61;
  font-weight: 700;
  border: none;
  padding: 10px 14px;
  border-radius: 6px;
  cursor: pointer;
  min-width: 132px;
}

html[data-brand="house-helper"] .categoryLanding {
  background: #f3f8ef;
}

html[data-brand="house-helper"] .cl-zipButton {
  background: #f4c430;
  color: #17351c;
}

html[data-brand="house-helper"] .cl-zipSecondaryButton {
  color: #1b5e20;
}

html[data-brand="house-helper"] .cl-locationStateCard {
  background: rgba(24, 83, 33, 0.66);
}

.cl-locationStateCard {
  margin: 4px 14px 14px;
  max-width: 430px;
  padding: 18px 18px 16px;
  border-radius: 18px;
  background: rgba(9, 30, 66, 0.58);
  backdrop-filter: blur(8px);
  box-shadow: 0 14px 34px rgba(2, 20, 52, 0.28);
}

.cl-locationStateCard--fullWidth {
  width: 100%;
  max-width: none;
  margin: 0;
}

.cl-locationEyebrow {
  margin-bottom: 10px;
  color: #ffd79a;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.cl-locationStateTitle {
  margin-bottom: 8px;
  color: #ffffff;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.25;
}

.cl-locationStateCopy {
  margin-bottom: 16px;
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  line-height: 1.55;
}

.cl-locationSpinner {
  width: 26px;
  height: 26px;
  margin-bottom: 14px;
  border-radius: 999px;
  border: 3px solid rgba(255, 255, 255, 0.28);
  border-top-color: #ff9f1c;
  animation: cl-spin 0.85s linear infinite;
}

@keyframes cl-spin {
  to {
    transform: rotate(360deg);
  }
}

.cl-proximityPrompt {
  margin: 4px 0 14px 14px;
  max-width: 360px;
  color: #ffffff;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.35;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.12);
}

.cl-proximityOptions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 12px;
}

.cl-proximityOption {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-height: 50px;
  padding: 0 16px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.92);
  border: 2px solid transparent;
  box-shadow: 0 8px 20px rgba(5, 44, 84, 0.14);
  color: #153a61;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: border-color 0.16s ease, transform 0.16s ease, box-shadow 0.16s ease;
}

.cl-proximityOption:hover {
  transform: translateY(-1px);
  box-shadow: 0 12px 24px rgba(5, 44, 84, 0.18);
}

.cl-proximityOption.selected {
  border-color: #ff9f1c;
  box-shadow: 0 0 0 3px rgba(255, 159, 28, 0.16);
}

.cl-proximityOption input {
  margin: 0;
  accent-color: #ff9f1c;
}

.cl-heroDisclaimer {
  font-size: 11px;
  opacity: 0.8;
  justify-self: center;
  
}

.cl-heroTopRow,
.cl-heroUtilityRow,
.cl-heroMatchRow {
  width: 100%;
}

.cl-heroTopRow {
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(300px, 0.95fr);
  gap: 28px;
  align-items: start;
}

.cl-heroMediaColumn {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 14px;
  width: 100%;
}

.cl-heroMatchRow {
  margin-top: 14px;
}

.cl-heroRowError {
  margin: 0 0 12px;
}

.cl-locationFooter {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 16px;
  margin-top: 12px;
}

.cl-locationFooterSpacer {
  min-width: 132px;
  min-height: 44px;
}

.cl-heroDisclaimer--card {
  margin: 10px auto 0;
  text-align: left;
  max-width: 100%;
  width: auto;
  display: block;
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
  line-height: 1.45;
}

.cl-heroDisclaimer--media {
  margin-top: 8px;
  text-align: center;
}

.cl-heroArt {
  order: 2;
  display: flex;
  align-items: flex-start;
  padding-bottom: 0;
  margin-top: 10px;
}

.cl-locationActionRow {
  margin-top: 8px;
}


.cl-twoCol {
  width: 766px;
    display: grid;
    grid-template-columns: 47.5% 52.5%;
    margin-top: 0px;
    justify-self: center;
    /* max-width: 920px; */
    /* align-items: flex-start; */
    column-gap: 7px;
}

@media (max-width: 550px) {
  .cl-twoCol {
    display: block;
  }
}

.cl-checkMark {
  color: #22c55e;
  font-weight: 700;
  margin-top: 2px;
}

/* ===== CHECKLIST ALIGNMENT ===== */

.cl-checkItem {
  display: flex;
  align-items: flex-start;
  gap: 4px;
}

.cl-checkMark {
  flex-shrink: 0;
  font-size: 18px;
  line-height: 1.4;
  margin-top: 2px;
  margin-left: 7px;
}

.cl-checkItem span:last-child {
  line-height: 1.6;
  font-weight: 500;
  font-size: 19px;
}

.cl-featureImage {
  height:100%;
  width:350px;
  border-radius: 12px;
}

/* ===== ADVANTAGES SECTION ===== */

.cl-advantages {
  background: #ffffff;
  border-radius: 2px;
  margin: 64px auto;
  
}

.cl-advantages h2 {
  font-size: 36px;
  margin-bottom: 12px;
}

.cl-advantages p {
  font-size: 18px;
  color: #475569;
  margin-bottom: 0px;
  font-size:15px;
}

/* Cards grid */
.cl-advantagesGrid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1px;
}

/* Individual card */
.cl-advCard {
  background: #f8fafc;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.06);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.cl-advCard:hover {
  transform: translateY(-4px);
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.1);
}

.cl-advCard img {
  width: 100%;
  border-radius: 12px;
  margin-bottom: 16px;
}

.cl-advCard h3 {
  font-size: 20px;
  margin-bottom: 8px;
}

.cl-advCard p {
  font-size: 15px;
  color: #475569;
}


/* ===== BENEFITS GRID ===== */

.cl-benefits {
  padding: 22px 0;
  
}

.cl-benefits h2 {
  font-size: 34px;
  margin-bottom: 21px;
}

.cl-benefitsGrid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
}

.cl-benefitItem {
  background: #ffffff;
  border-radius: 18px;
  padding: 28px;
  box-shadow: 0 14px 32px rgba(0, 0, 0, 0.06);
}

.cl-benefitItem img {
      justify-self: center;
    margin-left: 10px;
    list-style: none;
    padding-bottom: 5px;
    margin-left: 0px;
    display: grid;
    margin-right: 26px;
    height: fit-content;
}

.cl-benefitItem h3 {
  font-size: 20px;
  margin-bottom: 8px;
}

.cl-benefitItem p {
  font-size: 15px;
  color: #475569;
}



/* ===== GALLERY ===== */

.cl-gallery {
  width: 650px;
  background: #ffffff;
  border-radius: 16px;
  border: solid 1px #e2e8f0;
}

.cl-gallery h2 {
  font-size: 19px;
  margin-top: 10px;
}

.cl-galleryFrame {
  border-radius: 24px;
  padding: 0px;
  width: 100%;
  margin-bottom:-20px;
}

.cl-galleryFrame img {
  border-radius: 16px;
  max-width: 80%px;
  max-height:200px;
}

/* ===== REVIEWS ===== */

.cl-reviews {
  padding-top: 20px;
  
  
}

.cl-reviews h2 {
  font-size: 34px;
  margin-bottom: 18px;
}

.cl-reviewCard {
  border: solid 1px #e2e8f0;
  background: #ffffff;
  border-radius: 20px;
  padding: 10px;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.08);
  text-align: center;
  margin-bottom: 10px;
  width: 300px;
}

.cl-reviewAvatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  margin: 0 auto 12px;
  background: #e2e8f0;
  overflow: hidden;
  flex: 0 0 auto;
}

.cl-reviewAvatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.cl-reviewName {
  font-weight: 600;
  margin-bottom: 6px;
}
.cl-reviewGrid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  justify-items: center;
  padding-top: 5px;
}


.cl-reviewStars {
  color: #f59e0b;
  margin-bottom: 12px;
}

.cl-reviewText {
  font-size: 15px;
  color: #475569;
}
/* ===== FAQ — HEADER STYLE (NOT BUTTONS) ===== */
/* FAQ container */
.cl-faq {
   width: 56%;
  max-width: 900px;
  padding-top:25px;
  padding-bottom:25px;
}

/* FAQ list */
.cl-faqList {
  border-top: 1px solid #e5e7eb;
  width: 95%;
}

/* Each item */
.cl-faqItem {
  border-bottom: 1px solid #e5e7eb;
  padding: 18px 0;
}

/* Question row — NOT a button visually */
.cl-faqQ {
  display: flex;
  align-items: center;
  justify-content: space-between;

  background: none;
  border: none;
  padding: 0;

  font-size: 15px;
  font-weight: 600;
  color: #111827;

  cursor: pointer;
}

/* Question text */
.cl-faqQText {
  max-width: 90%;
  padding-left: 8px;
}

/* Chevron */
.cl-faqChevron {
  width: 10px;
  height: 10px;
  border-right: 2px solid #6b7280;
  border-bottom: 2px solid #6b7280;
  transform: rotate(45deg);
  transition: transform 0.2s ease;
}

/* Open state */
.cl-faqItem.isOpen .cl-faqChevron {
  transform: rotate(-135deg);
}

/* Answer */
.cl-faqA {
  margin: 4px;
  font-size: 15px;
  line-height: 1.6;
  color: #374151;
  max-width: 720px;
  padding-left: 5px;
}

/* Focus styles for accessibility */
.cl-faqQ:focus {
  outline: none;
}

.cl-faqQ:focus-visible {
  outline: 2px solid #2563eb;
  outline-offset: 4px;
}

html[data-brand="house-helper"] .cl-faqQ:focus-visible {
  outline-color: #2f7d32;
}

html[data-brand="house-helper"] .featured-tool-box {
  border-color: rgba(124, 194, 67, 0.5);
}




/* ================================
   SKELETON LOADERS
================================ */

@keyframes skeletonPulse {
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
}

.cl-skeleton {
  background: linear-gradient(
    90deg,
    #e5e7eb 25%,
    #f3f4f6 37%,
    #e5e7eb 63%
  );
  background-size: 400px 100%;
  animation: skeletonPulse 1.4s ease infinite;
  border-radius: 12px;
}

/* ===== GALLERY SKELETON ===== */

.cl-gallerySkeleton {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.cl-gallerySkeletonItem {
  aspect-ratio: 4 / 3;
  border-radius: 16px;
}


/* ===== REVIEWS SKELETON ===== */

.cl-reviewSkeleton {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 28px;
}

.cl-reviewSkeletonCard {
  background: #ffffff;
  border-radius: 20px;
  padding: 28px;
}

.cl-reviewSkeletonAvatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  margin: 0 auto 14px;
}

.cl-reviewSkeletonLine {
  height: 14px;
  border-radius: 6px;
  margin-bottom: 10px;
}

.cl-reviewSkeletonLine.short {
  width: 60%;
  margin: 10px auto 0;
}

.cl-galleryThumbs {
  display: flex;
  gap: 12px;
  overflow-x: auto;
    max-width: 102%;
  overflow-x: auto;
  justify-content: center;
  margin-bottom: 25px;
}

.cl-galleryThumb {
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  opacity: 0.6;
}

.cl-galleryThumb.isActive {
  opacity: 1;
  outline: 2px solid #6366f1;
  border-radius: 8px;
}

.cl-galleryThumb img {
  height: 64px;
  width: auto;
  border-radius: 8px;
  display: block;
}




/* ===== MOBILE IMAGE CONSTRAINTS ===== */




.cl-cardImg {
    max-width: 300px;
    padding:15px;
}
.cl-container {
  width: 100%;
  max-width: 800px;
  text-align: left;
  padding-right: 5px;
  padding-left: 5px;
  height:auto;
  padding-top: 0px;
  justify-items: center;
    
}
/* ===== ZIP VALIDATION ERROR ===== */

/* ===== ZIP VALIDATION (BRIGHT YELLOW) ===== */

.cl-zipError {
  color: #fde047; /* yellow-300 */
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
  height: 12px;
  padding-left: 35px;
}

.cl-zipRow {
  width: 90%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}

.cl-zipRow--stackMobile {
  width: 100%;
}

.cl-zipInput[aria-invalid="true"] {
  border: 2px solid #facc15; /* yellow-400 */
  box-shadow: 0 0 0 2px rgba(250, 204, 21, 0.35);
}



.cl-breadcrumbRow {
    padding-top: 10px;
    padding-bottom: 5px;
    font-size: 10pt;
    padding-left: 10px;
    font-weight: 600;
}

.cl-section {
    vertical-align: top;
    
}
.cl-body{
    font-size: 16px;
    color: #475569;
    margin: 7px 9px -8px 18px;
    text-align: center;
}
 .cl-h2 {
    margin-bottom: 7px;
    font-weight: 700;
    text-align: center;
    font-size:23px;
  }




/* =========================================
   TABLET AND DESKTOP — REMOVE HERO CLIPPING
========================================= */
@media (min-width: 550px) {


      .featuredContractorCard-OLD {
        
        
        
        padding-bottom: 5px;
        box-shadow: 0 2px 10px rgba(0,0,0,0.08);
        margin-top: 10px !important;
        max-width: 63% !important;
        justify-self: center;
      }

      .cl-proximityPrompt {
        max-width: 420px;
      }

      .featuredContractorCard {
                background: #fff;
        padding: 3px 8px;
        border-radius: 12px;
        position: relative;
        z-index: 5;
        margin-top: 15px !important;
        max-width: 722px !important;
        width: 100%;
        justify-self: center;
        margin-left: auto;
        margin-right: auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
      }

      .featuredContractorInner {
        display: flex;
        gap: 12px;
        align-items: center;
        margin-top: -4px;
        width: 100%;
      }

      .featuredContractorImage {
        flex-shrink: 0;
        max-width: 180px;
      }

      .featuredContractorImage img {
                display: block;
        height: 120px;/*  */
        width: auto;
        border-radius: 8px;
        /* object-fit: cover; */
        max-width: 159px;
      }

      .featuredContractorContent {
        flex: 1;
      }

      .featuredContractorContent h3 {
        font-size: 14px;
        color: #6b7280;
        margin-bottom: 4px;
      }

      .featuredContractorContent h2 {
        font-size: 18px;
        margin: 0;
      }

      .featuredContractorContent p {
        font-size: 14px;
        margin: 6px 0 10px;
      }

      .primaryButton {
        background: #f59e0b;
        border: none;
        padding: 8px 14px;
        border-radius: 6px;
        cursor: pointer;
        font-weight: 600;
      }

      .featuredContractorButton {
        margin-left: auto;
        white-space: nowrap;
      }

  .cl-h2-b {
       font-weight: 700;
    text-align: left;
    font-size: 23px;
    width: 106%;
  }

  .heroModalContent {
            /* width: 50%; */
        max-width: 650px;
        justify-self: center;
        margin-top: 95px;
  }

.cl-benefitBody {
  font-size: 15px;
  line-height: 1.6;
  color: #475569;
  width: 476px;
}


.cl-benefitGrid {
  display: grid;
  justify-self: center;
  gap: 20px;
  margin-left: 15px;
  margin-right: 15px;
}

.cl-benefit {
  display: grid;
  grid-template-columns: 20px 1fr;
  column-gap: 12px;
  align-items: start;
  margin-top: 5px;
}

.cl-benefitIcon {
  font-size: 23px;
}

.cl-benefitText {
  display: block;
}

.cl-benefitTitle {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 4px;
}


.cl-helpButtonContainer {
	       justify-self: center;
	    padding: 10px 20px;
        border-radius: 40px;
        border: none;
        background: rgba(255, 255, 255, 0.18);
        backdrop-filter: blur(8px);
        color: #ffffff;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.25s ease;
	    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.2);
	    /* display: block; */
	    margin-bottom: 10px;
	    margin-left: 0;
	            width: 100%;
      max-width: 300px;
}

/* ================================================= */
/* FEATURED TOOL BOX (GENERIC CARD STYLE) */
/* ================================================= */

        .featured-tool-box {
          background: #fff;
        border-radius: 16px;
        padding: 12px 24px 2px 24px;
        box-shadow: 0 12px 24px rgba(0, 0, 0, 0.08);
        border: 1px solid #3690ffa2;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        /* max-width: 720px; */
        width: 96%;
        justify-self: center;
        margin-top: 15px;;
        }

	        .cl-heroGrid {
	        width: 780px;
	        text-align: left;
	        display: flex;
	        flex-direction: column;
	        }

        .cl-heroCopy{
        order: 1;
        width: 67%;
        }
        .foundation-bubbles-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 17px;

        }
        .cl-heroImg{  
        width: 99%;
        height: auto;
        margin-top: 10px;
        margin-bottom: 10px;
        border-radius: 14px;
        margin-right: 62px;
        margin-left: 10px;
        }

        .cl-benefits {
        padding: 22px 21px;
        width: 70%;
        }

        .foundation-card {
        background: #ffffff;
        border-radius: 20px;
        padding: 13px;
        box-shadow:
        0 6px 18px rgba(0, 0, 0, 0.06),
        0 1px 2px rgba(0, 0, 0, 0.04);

        display: flex;
        flex-direction: column;
        gap: 14px;
        margin-top: 20px;
        margin-bottom: 20px;
        width: 100%;
        }

        .cl-checkList {
        list-style: none;
        padding-bottom: 5px;
        }

   



        .cl-hero {
        padding-bottom: 10px;
        justify-content: center;
        display: flex;
        }

        .cl-heroArt {
        display: block;
        order: 2;
        }


        .cl-featureImageWrap {
        border-radius: 10px;
        padding: 4px;


        } 

        .cl-advantagesGrid {
        grid-template-columns: 1fr;
        }

        .cl-advantages {
        border-radius: 0;
        margin: 0;
        }

        .cl-benefitsGrid {
        grid-template-columns: 1fr;
        }
        .cl-gallerySkeleton {
        grid-template-columns: 1fr;
        }
        .cl-reviewSkeleton {
        grid-template-columns: 1fr;
        }


        .cl-zipForm {
        display: flex;
        margin-bottom: 10px;
        width: 100%;
        margin-left: 15px;

        }
        .cl-zipButton {
        background: #ff9f1c;
        color: #111;
        font-weight: 600;
        border: none;
        padding: 10px 8px;
        border-radius: 6px;
        cursor: pointer;
        width: 117px;
        margin-left: 10px;
        }

}
.cl-showDesktop {
    align-content: center;
    min-height: 345px;
    padding-top: 15px
  }

.cl-showMobile {
  display: none;
}

.cl-hero {
  position: relative;
  background-size: cover;
  background-position: center;
  color: #fff;
  padding-top: 5px;
  
}
.cl-hero::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, #79b7f2 0%, rgba(29, 180, 255, 0.9));
  z-index: 0;
}

html[data-brand="house-helper"] .cl-hero::before {
  background:
    radial-gradient(820px 420px at 14% 28%, rgba(255, 255, 255, 0.22), transparent 58%),
    linear-gradient(135deg, #7cc243 0%, rgba(47, 125, 50, 0.94));
}
.cl-heroInner {
  position: relative;
  display:flex;
  z-index: 1;
  
}


.cl-heroTitle {
  font-size: 23px;
    font-weight: 700;
    line-height: 1.15;
    margin-bottom: 8px;
    margin-top: 11px;
    margin-left: 6px;
    /* margin-right: 15px; */
    color: #005cac;
}

html[data-brand="house-helper"] .cl-heroTitle {
  color: #1b5e20;
}

.cl-heroSubtitle {
  font-size: 18px;
  opacity: 0.95;
  margin-bottom: 10px;
  margin-left: 10px;
  margin-right: 15px;
}


.featuredToolBand {
  width: 100%;
  display: flex;
  justify-content: center;

  /* Visually separate from text column */
  
}
.cl-cardGrid {
  
  padding-bottom: 20px;
  
} 
.toolsGrid {
  padding: 0px 0;
}
.foundation-bubbles {
    padding-top: 25px;
    width: 96%;
    max-width: 800px;
    text-align: center;
    padding-right: 10px;
    padding-left: 13px;
    height: auto;
    justify-items: center;
}



.foundation-item {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.bubble {
  background: #ffffff;
  border-radius: 18px;
  padding: 16px;
  box-shadow:
    0 6px 18px rgba(0, 0, 0, 0.06),
    0 1px 2px rgba(0, 0, 0, 0.04);
}
.bubble-image {
  padding: 0;
  overflow: hidden;
}

.bubble-image img {
  width: 100%;
  height: 180px;
  object-fit: cover;
  display: block;
  border-radius: 18px;
}

.bubble-title h3 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 700;
  color: #1f2937;
}

.bubble-subtitle p {
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.5;
  color: #4b5563;
}


/* Mobile */
@media (max-width: 550px) {


        .featuredContractorCard {
          background: #fff;
          border-radius: 12px;
          padding: 10px 12px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.08);
          margin-top: 20px !important;
          justify-self: center !important;
          margin-left: 0px;
          max-width: 94% !important;
          width: calc(100% - 12px);
        }

        .featuredContractorInner {
          display: flex;
          gap: 10px;
          align-items: center;
          width: 100%;
        }

        .featuredContractorImage {
          width: 56px;
          height: 56px;
          flex: 0 0 56px;
          flex-shrink: 0;
        }

        .featuredContractorImage img {
          width: 56px;
          height: 56px;
          max-width: 56px;
          max-height: 56px;
          border-radius: 12px;
          object-fit: cover;
          object-position: center;
          display: block;
        }

        .featuredContractorContent  {
          flex: 1 1 auto;
          min-width: 0;
          margin-top: 0;
        }

        .featuredContractorContent h3 {
          font-size: 11px;
          color: #6b7280;
          margin-bottom: 3px;
          margin-top: 0px;
        }

        .featuredContractorContent h2 {
          font-size: 16px;
          margin: 0;
          text-align: left;
          line-height: 1.15;
        }

        .featuredContractorContent p {
          font-size: 12px;
          line-height: 1.35;
          margin: 4px 0 0;
        }

        .primaryButton {
          background: #f59e0b;
          border: none;
          padding: 8px 14px;
          border-radius: 6px;
          cursor: pointer;
          font-weight: 600;
          margin-bottom: 10px;
        }

        .featuredContractorButton {
          margin-left: 0;
          flex: 0 0 auto;
          align-self: center;
          min-width: 96px;
          padding: 10px 12px;
          white-space: nowrap;
        }


          .cl-h2-b {
             margin-bottom: 7px;
        margin-top: -36px;
        font-weight: 700;
        text-align: left;
        font-size: 24px;
        margin-left: 4px;
        max-width: 110%;
          }

          .cl-benefitBody {
          font-size: 15px;
          line-height: 1.6;
          color: #475569;
          }


          .cl-benefitGrid {
          display: grid;
          gap: 20px;
          margin-left: 15px;
          margin-right: 15px;
          }

          .cl-benefit {
          display: grid;
          grid-template-columns: 21px 1fr;
          column-gap: 6px;
          align-items: start;
          margin-top: 5px;
          }

          .cl-benefitIcon {
          font-size: 23px;
          }

          .cl-benefitText {
          display: block;
          }

          .cl-benefitTitle {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 4px;
          }


          .cl-hero {
          position: relative;
          background-size: cover;
          background-position: center;
          color: #fff;
          padding-top: 5px;

          }
          .cl-hero::before {
          content: "";
          position: absolute;
          inset: 0;
          background: linear-gradient(135deg, #79b7f2 0%, rgba(29, 180, 255, 0.9));
          z-index: 0;
          }
          .cl-heroInner {
          position: relative;
          display:flex;
          z-index: 1;

          }

	          .cl-heroGrid {
	          display: inline;
	          grid-template-columns: 1.1fr 0.9fr;
	          align-items: start;     /* 🔑 prevents vertical stretching */

	          }

	          .cl-heroTopRow {
	          display: block;
	          }

          .cl-heroMediaColumn {
          gap: 10px;
          align-items: center;
          }

          .cl-heroTitle {
            font-size: 23px;
          font-weight: 700;
          line-height: 1.15;
          margin-bottom: 8px;
          margin-top: 9px;
          margin-left: 11px;
          margin-right: 5px;
          color: #005cac;
          width: 100%;
          }

          .cl-heroSubtitle {
            font-size: 18px;
          opacity: 0.95;
          margin-bottom: 10px;
          width: 100%;
          margin-left: 12px;
          margin-right: 5px;
          }

          .cl-faq {
          margin: 14px ;
          width: 100%;
          max-width: 900px;
          padding-top:25px;
          padding-bottom:25px;
          }



          .cl-heroArt img {
          border-radius: 14px;
          width: 90%;
          }

          .cl-gallery {
          width: 94%;
          background: #ffffff;
          border-radius: 16px;
          border: solid 1px #e2e8f0;
          }

          .cl-h2 {
          margin-bottom: 7px;
          font-weight: 700;
          padding-left: 18px;
          padding-right: 5px;
          font-size: 19px;
          }

          .cl-reviewGrid {
          display: grid;
          grid-template-columns: repeat(1, 1fr);
          gap: 24px;
          justify-items: center;
          }
          .cl-heroDisclaimer {
          font-size: 11px;
          opacity: 0.8;
          margin-left: 8px;
          }

          .cl-breadcrumbRow {
            line-height: 0.1em;
          padding-top: 10px;
          padding-bottom: 5px;
          font-size: 10pt;
          padding-left: 10px;
          font-weight: 600;
          }

          .cl-checkItem {
          display: flex;
          align-items: flex-start;
          gap: 6px;
          width: 98%;
          font-weight: 500;
          }

          .cl-checkItem span:last-child {
          font-size: 17px;
          }


          .cl-gallery h2 {
          font-size: 20px;
          margin-top: 12px;
          }


          .cl-heroCopy {
              order: 1;
          width: 94%;
          }

	          .cl-heroArt {
	          justify-content: center;order: 2;
	          width: 100%;
	          }

          .cl-galleryFrame img {
          max-height:200px;
          }
          .cl-twoCol {
          width: 100%;
          display: block;

          }


          .cl-checkList {
             list-style: none;
        padding-bottom: 5px;
        margin-left: -28px;
        margin-right: 10px;

          }

          .cl-zipForm {
          display: flex;
          width: 100%;

          }

          .cl-zipRow {
          display: flex;
          gap: 7px;
          align-items: left;   
          width: 276px;
          }

          .cl-zipRow--stackMobile {
          width: 100%;
          flex-direction: column;
          align-items: stretch;
          }

	          .cl-zipInput,
	          .cl-zipButton,
	          .cl-zipSecondaryButton {
	          width: 100%;
	          }

            .cl-zipInput--manualEntry {
            flex: 0 0 200px;
            width: 200px;
            }

	          .cl-locationStateCard--fullWidth {
	          margin: 0 8px;
	          width: calc(100% - 16px);
	          }

	          .cl-heroUtilityInner {
	          align-items: flex-start;
	          padding: 0 8px;
	          }

	          .cl-helpButtonContainer {
	          width: auto;
	          margin-left: 0;
	          }

          .cl-locationFooter {
          flex-direction: column;
          align-items: flex-start;
          }

          .cl-locationFooterSpacer {
          display: none;
          }

          .cl-heroDisclaimer--card {
          margin-left: 0;
          text-align: left;
          max-width: none;
          }

          .cl-galleryFrame {
          aspect-ratio: 4 / 3;
          overflow: hidden;
          }

          .cl-h2 {
            font-weight: 700;
            padding-left: 0px;
            text-align: center;
          }


          .cl-advantages,
          .cl-reviews  {
          margin: 14px auto 0 auto;
          max-width: 900px;
          }



          .cl-valueProps .cl-featureImage {
          display: block;
          }

          .cl-valueProps {
          min-height: 324px;
          padding-bottom: 10px;
          justify-content: center;
          display: flex;
          }

          .cl-showDesktop {
          display: none;
          }
          .cl-showMobile {
          display: block;
          }

          .cl-featureImageWrap {
          border-radius: 10px;

          } 

          .cl-featureImage {
          width: 100%;
          border-radius: 12px;
          display: block;
          }
          /* ================================================= */
          /* FEATURED TOOL BOX (GENERIC CARD STYLE) */
          /* ================================================= */

          .featured-tool-box {
          background: #fff;
          border-radius: 16px;
          padding: 19px 12px;
          box-shadow: 0 12px 24px rgba(0, 0, 0, 0.08);
          border: 1px solid #3690ffa2;
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          max-width: 720px;
          width: 89%;
          margin: 8px auto;
          }

          .foundation-bubbles {
          display: block;
          padding-top:25px;
          width: 100%;
          max-width: 800px;
          text-align: center;
          height:auto;
          justify-items: self;
          }


          .foundation-card {
          background: #ffffff;
          border-radius: 20px;
          padding: 13px;
          box-shadow:
          0 6px 18px rgba(0, 0, 0, 0.06),
          0 1px 2px rgba(0, 0, 0, 0.04);

          display: flex;
          flex-direction: column;
          gap: 14px;
          margin-top: 20px;
          margin-bottom: 20px;
          width: 100%;
          }


        .heroModalOverlay {
          align-items: flex-end;
        }

        .heroModalContent {
                  width: 85%;
              border-radius: 24px;
              padding: 10px 11px;
              justify-self: center;
              margin-top: 25px;
        }

        .heroHelpButton {
          width: 100%;
          margin-top: 16px;
        }
        

	        .cl-heroGrid {
	          display: flex;
	          flex-direction: column;
	        }

	        .cl-heroTopRow {
	          display: flex;
	          flex-direction: column;
	          gap: 12px;
	        }

	        .cl-heroMediaColumn {
	          width: 100%;
	          align-items: center;
	        }

        .cl-heroCopy {
          order: 1;
          width: 94%;
        }

        /* Container becomes column */
        .cl-heroArt {
          order: 2;
              display: flex;
              flex-direction: column-reverse;
              align-items: center;
              width: 100%;
              justify-self: center;
        }

        /* Button styles */
        .heroHelpButton {
                width: 69%;
              
              display: flex;
              justify-self: center;
        }

        /* Image styles */
        .cl-heroArt img {
          width: 90%;
          border-radius: 14px;
        }

	        .cl-helpButtonContainer {
	                  padding: 10px 20px;
              border-radius: 40px;
              border: none;
              background: rgba(255, 255, 255, 0.18);
              backdrop-filter: blur(8px);
              color: #ffffff;
              font-weight: 600;
              cursor: pointer;
              transition: all 0.25s ease;
	              box-shadow: 0 6px 18px rgba(0, 0, 0, 0.2);
	              display: block;
	              margin-bottom: 10px;
	              margin-left: 0;
	      }

	        .cl-heroUtilityInner {
	          padding: 0 13px;
	          gap: 8px;
	        }

	        .cl-locationStateCard--fullWidth {
	          width: calc(100% - 26px);
	          margin: 0 13px;
	        }

	        .cl-locationFooter {
	          flex-direction: column;
	          align-items: flex-start;
	        }

	        .cl-locationFooterSpacer {
	          display: none;
	        }

	        .cl-heroDisclaimer--card {
	          margin-left: 0;
	          text-align: left;
	          max-width: none;
	        }

}

.foundation-card-image {
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: 16px;
}

/* Hero layout overrides */
.cl-heroTopRow {
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(320px, 0.95fr);
  gap: 28px;
  align-items: start;
}

.cl-heroCopyColumn {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
}

.cl-heroCopy {
  order: 1;
  width: 100%;
}

.cl-heroMediaColumn {
  order: 2;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 14px;
  width: 100%;
}

.cl-heroMediaColumn .cl-heroArt {
  order: 1;
  width: 100%;
  justify-content: flex-end;
  margin-top: 0;
}

.cl-heroInlineCard {
  order: 2;
  width: 100%;
  max-width: 590px;
}

.cl-heroInlineCard .cl-locationStateCard--fullWidth {
  width: 100%;
  max-width: none;
}

.cl-heroInlineCard .cl-locationStateCard {
  margin: 0;
  padding: 14px 16px 12px;
}

.cl-heroInlineCard .cl-proximityPrompt {
  margin: 2px 0 10px;
  max-width: none;
  font-size: 18px;
  line-height: 1.25;
}

.cl-heroInlineCard .cl-locationEyebrow {
  margin-bottom: 6px;
}

.cl-heroInlineCard .cl-locationStateCopy {
  margin-bottom: 12px;
  font-size: 13px;
  line-height: 1.45;
}

.cl-heroInlineCard .cl-zipForm {
  margin-left: 0;
  margin-bottom: 6px;
}

.cl-heroInlineCard .cl-zipRow {
  gap: 10px;
  align-items: center;
}

.cl-heroInlineCard .cl-proximityOptions {
  margin-bottom: 0;
}

.cl-helpButtonContainer--media {
  order: 2;
  width: 100%;
  max-width: 300px;
  align-self: center;
  margin: 0 auto;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  visibility: visible;
  opacity: 1;
}

.cl-heroMediaColumn .cl-heroDisclaimer--media {
  order: 3;
  width: 100%;
  align-self: center;
}

@media (max-width: 900px) {
  .cl-heroTopRow {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .cl-heroMediaColumn {
    align-items: center;
  }

  .cl-heroMediaColumn .cl-heroArt {
    justify-content: center;
  }

  .cl-heroInlineCard {
    max-width: none;
  }

  .cl-helpButtonContainer--media {
    width: 100%;
    max-width: 320px;
  }
}
.foundation-card-title {
  
  text-align: center;
}

.foundation-card-body {
  margin: 0;
  margin-top: -19px;
  margin-left: 0px;
  line-height: 1.3em;
}



.heroHelpButton {
  margin-top: 18px;
  padding: 12px 22px;
  border-radius: 40px;
  border: none;
  background: rgba(255,255,255,0.18);
  backdrop-filter: blur(10px);
  color: #fff;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 6px 18px rgba(0,0,0,0.2);
}

.heroHelpButton:hover {
  background: rgba(255,255,255,0.28);
  transform: translateY(-2px);
}

.heroModalOverlay {
      width: 100%;
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.55);
  z-index: 9999;
}

.heroModalContent {
  margin: 20px;
  max-height: 90vh;
  max-width: 95vh;
  overflow-y: auto;
  justify-self: center;
  background: #fff;
  padding: 15px;
  border-radius: 24px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.25);
  text-align: center;
  animation: fadeInScale 0.2s ease forwards;
}

.heroModalContent h3 {
  margin-bottom: 10px;
  margin-top: 0px;
  color: #0075cfd9;
}

.heroModalContent p {
  margin-top: 4px;
  line-height: 1.3;
  color: #333;
}

.heroModalClose {
  margin-top: 4px;
  padding: 12px 26px;
  border-radius: 30px;
  border: none;
  background: linear-gradient(135deg,#0075cf,#004fa3);
  color: #fff;
  font-weight: 600;
  cursor: pointer;
}

html[data-brand="house-helper"] .heroModalContent h3 {
  color: #2f7d32;
}

html[data-brand="house-helper"] .heroModalClose {
  background: linear-gradient(135deg, #7cc243, #2f7d32);
}


@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.96);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}


@media (max-width: 320px) {

  .cl-h2-b {
       font-weight: 700;
    text-align: left;
    font-size: 17px;
    width: 106%;
  }
  .cl-checkList {
           list-style: none;
        padding-bottom: 5px;
        margin-left: -26px;

    }

    .featuredContractorCard {
        background: #fff;
        border-radius: 12px;
        padding: 6px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
        margin-top: 20px !important;
        max-width: 91% !important;
        margin-left: 7px;
        justify-content: left;
        display: flex;
        
      }

    .featuredContractorImage,
    .featuredContractorImage img {
        width: 48px;
        height: 48px;
        max-width: 48px;
        max-height: 48px;
    }

}
`, "",{"version":3,"sources":["webpack://./src/assets/stylesheets/CategoryLanding.css"],"names":[],"mappings":";AACA,uCAAuC;;AAEvC;;EAEE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;;AAGA,6BAA6B;;;AAG7B;EACE,UAAU;EACV,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,iBAAiB;IACf,eAAe;EACjB,kBAAkB;EAClB,YAAY;EACZ,YAAY;;AAEd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,iCAAiC;EACjC,0BAA0B;EAC1B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,2CAA2C;EAC3C,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,qCAAqC;EACrC,6BAA6B;EAC7B,4CAA4C;EAC5C,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gFAAgF;AAClF;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,oBAAoB;;AAEtB;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8DAA8D;EAC9D,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;;AAGA;EACE,YAAY;IACV,aAAa;IACb,kCAAkC;IAClC,eAAe;IACf,oBAAoB;IACpB,sBAAsB;IACtB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,oCAAoC;;AAEpC;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA,mCAAmC;;AAEnC;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;;AAEnB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,2CAA2C;EAC3C,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;;AAGA,8BAA8B;;AAE9B;EACE,eAAe;;AAEjB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,2CAA2C;AAC7C;;AAEA;MACM,oBAAoB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;;;AAIA,wBAAwB;;AAExB;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,wBAAwB;;AAExB;EACE,iBAAiB;;;AAGnB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,qBAAqB;EACrB,gBAAgB;AAClB;;;AAGA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;AACA,iDAAiD;AACjD,kBAAkB;AAClB;GACG,UAAU;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,6BAA6B;EAC7B,UAAU;AACZ;;AAEA,cAAc;AACd;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;;EAE9B,gBAAgB;EAChB,YAAY;EACZ,UAAU;;EAEV,eAAe;EACf,gBAAgB;EAChB,cAAc;;EAEd,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,gCAAgC;EAChC,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA,eAAe;AACf;EACE,0BAA0B;AAC5B;;AAEA,WAAW;AACX;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,mCAAmC;AACnC;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;AACvC;;;;;AAKA;;kCAEkC;;AAElC;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE;;;;;GAKC;EACD,2BAA2B;EAC3B,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA,iCAAiC;;AAEjC;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;;AAGA,iCAAiC;;AAEjC;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;IACd,eAAe;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,YAAY;AACd;;AAEA;EACE,UAAU;EACV,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;;;;AAKA,yCAAyC;;;;;AAKzC;IACI,gBAAgB;IAChB,YAAY;AAChB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;;AAEvB;AACA,qCAAqC;;AAErC,+CAA+C;;AAE/C;EACE,cAAc,EAAE,eAAe;EAC/B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB,EAAE,eAAe;EAC1C,8CAA8C;AAChD;;;;AAIA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;;AAEvB;AACA;IACI,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,kBAAkB;AACtB;CACC;IACG,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;EAChB;;;;;AAKF;;2CAE2C;AAC3C;;;MAGM;;;;QAIE,mBAAmB;QACnB,uCAAuC;QACvC,2BAA2B;QAC3B,yBAAyB;QACzB,oBAAoB;MACtB;;MAEA;QACE,gBAAgB;MAClB;;MAEA;gBACU,gBAAgB;QACxB,gBAAgB;QAChB,mBAAmB;QACnB,kBAAkB;QAClB,UAAU;QACV,2BAA2B;QAC3B,2BAA2B;QAC3B,WAAW;QACX,oBAAoB;QACpB,iBAAiB;QACjB,kBAAkB;QAClB,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,SAAS;MACX;;MAEA;QACE,aAAa;QACb,SAAS;QACT,mBAAmB;QACnB,gBAAgB;QAChB,WAAW;MACb;;MAEA;QACE,cAAc;QACd,gBAAgB;MAClB;;MAEA;gBACU,cAAc;QACtB,aAAa,CAAC,KAAK;QACnB,WAAW;QACX,kBAAkB;QAClB,uBAAuB;QACvB,gBAAgB;MAClB;;MAEA;QACE,OAAO;MACT;;MAEA;QACE,eAAe;QACf,cAAc;QACd,kBAAkB;MACpB;;MAEA;QACE,eAAe;QACf,SAAS;MACX;;MAEA;QACE,eAAe;QACf,kBAAkB;MACpB;;MAEA;QACE,mBAAmB;QACnB,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;QAClB,eAAe;QACf,gBAAgB;MAClB;;MAEA;QACE,iBAAiB;QACjB,mBAAmB;MACrB;;EAEJ;OACK,gBAAgB;IACnB,gBAAgB;IAChB,eAAe;IACf,WAAW;EACb;;EAEA;YACU,gBAAgB;QACpB,gBAAgB;QAChB,oBAAoB;QACpB,gBAAgB;EACtB;;AAEF;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;;AAGA;EACE,aAAa;EACb,oBAAoB;EACpB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;;AAGA;QACQ,oBAAoB;KACvB,kBAAkB;QACf,mBAAmB;QACnB,YAAY;QACZ,qCAAqC;QACrC,0BAA0B;QAC1B,cAAc;QACd,gBAAgB;QAChB,eAAe;QACf,0BAA0B;KAC7B,yCAAyC;KACzC,oBAAoB;KACpB,mBAAmB;KACnB,cAAc;aACN,WAAW;MAClB,gBAAgB;AACtB;;AAEA,sDAAsD;AACtD,2CAA2C;AAC3C,sDAAsD;;QAE9C;UACE,gBAAgB;QAClB,mBAAmB;QACnB,2BAA2B;QAC3B,2CAA2C;QAC3C,2BAA2B;QAC3B,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,kBAAkB;QAClB,sBAAsB;QACtB,UAAU;QACV,oBAAoB;QACpB,gBAAgB;QAChB;;SAEC;SACA,YAAY;SACZ,gBAAgB;SAChB,aAAa;SACb,sBAAsB;SACtB;;QAED;QACA,QAAQ;QACR,UAAU;QACV;QACA;QACA,aAAa;QACb,qCAAqC;QACrC,SAAS;;QAET;QACA;QACA,UAAU;QACV,YAAY;QACZ,gBAAgB;QAChB,mBAAmB;QACnB,mBAAmB;QACnB,kBAAkB;QAClB,iBAAiB;QACjB;;QAEA;QACA,kBAAkB;QAClB,UAAU;QACV;;QAEA;QACA,mBAAmB;QACnB,mBAAmB;QACnB,aAAa;QACb;;qCAE6B;;QAE7B,aAAa;QACb,sBAAsB;QACtB,SAAS;QACT,gBAAgB;QAChB,mBAAmB;QACnB,WAAW;QACX;;QAEA;QACA,gBAAgB;QAChB,mBAAmB;QACnB;;;;;;QAMA;QACA,oBAAoB;QACpB,uBAAuB;QACvB,aAAa;QACb;;QAEA;QACA,cAAc;QACd,QAAQ;QACR;;;QAGA;QACA,mBAAmB;QACnB,YAAY;;;QAGZ;;QAEA;QACA,0BAA0B;QAC1B;;QAEA;QACA,gBAAgB;QAChB,SAAS;QACT;;QAEA;QACA,0BAA0B;QAC1B;QACA;QACA,0BAA0B;QAC1B;QACA;QACA,0BAA0B;QAC1B;;;QAGA;QACA,aAAa;QACb,mBAAmB;QACnB,WAAW;QACX,iBAAiB;;QAEjB;QACA;QACA,mBAAmB;QACnB,WAAW;QACX,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;QAClB,eAAe;QACf,YAAY;QACZ,iBAAiB;QACjB;;AAER;AACA;IACI,qBAAqB;IACrB,iBAAiB;IACjB;EACF;;AAEF;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;;AAElB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,wEAAwE;EACxE,UAAU;AACZ;;AAEA;EACE;;gEAE8D;AAChE;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;;AAEZ;;;AAGA;EACE,eAAe;IACb,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,wBAAwB;IACxB,cAAc;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;;AAGA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;;EAEvB,uCAAuC;;AAEzC;AACA;;EAEE,oBAAoB;;AAEtB;AACA;EACE,cAAc;AAChB;AACA;IACI,iBAAiB;IACjB,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;AACzB;;;;AAIA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb;;iCAE+B;AACjC;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;;AAGA,WAAW;AACX;;;QAGQ;UACE,gBAAgB;UAChB,mBAAmB;UACnB,kBAAkB;UAClB,uCAAuC;UACvC,2BAA2B;UAC3B,+BAA+B;UAC/B,gBAAgB;UAChB,yBAAyB;UACzB,wBAAwB;QAC1B;;QAEA;UACE,aAAa;UACb,SAAS;UACT,mBAAmB;UACnB,WAAW;QACb;;QAEA;UACE,WAAW;UACX,YAAY;UACZ,cAAc;UACd,cAAc;QAChB;;QAEA;UACE,WAAW;UACX,YAAY;UACZ,eAAe;UACf,gBAAgB;UAChB,mBAAmB;UACnB,iBAAiB;UACjB,uBAAuB;UACvB,cAAc;QAChB;;QAEA;UACE,cAAc;UACd,YAAY;UACZ,aAAa;QACf;;QAEA;UACE,eAAe;UACf,cAAc;UACd,kBAAkB;UAClB,eAAe;QACjB;;QAEA;UACE,eAAe;UACf,SAAS;UACT,gBAAgB;UAChB,iBAAiB;QACnB;;QAEA;UACE,eAAe;UACf,iBAAiB;UACjB,eAAe;QACjB;;QAEA;UACE,mBAAmB;UACnB,YAAY;UACZ,iBAAiB;UACjB,kBAAkB;UAClB,eAAe;UACf,gBAAgB;UAChB,mBAAmB;QACrB;;QAEA;UACE,cAAc;UACd,cAAc;UACd,kBAAkB;UAClB,eAAe;UACf,kBAAkB;UAClB,mBAAmB;QACrB;;;UAGE;aACG,kBAAkB;QACvB,iBAAiB;QACjB,gBAAgB;QAChB,gBAAgB;QAChB,eAAe;QACf,gBAAgB;QAChB,eAAe;UACb;;UAEA;UACA,eAAe;UACf,gBAAgB;UAChB,cAAc;UACd;;;UAGA;UACA,aAAa;UACb,SAAS;UACT,iBAAiB;UACjB,kBAAkB;UAClB;;UAEA;UACA,aAAa;UACb,+BAA+B;UAC/B,eAAe;UACf,kBAAkB;UAClB,eAAe;UACf;;UAEA;UACA,eAAe;UACf;;UAEA;UACA,cAAc;UACd;;UAEA;UACA,eAAe;UACf,gBAAgB;UAChB,kBAAkB;UAClB;;;UAGA;UACA,kBAAkB;UAClB,sBAAsB;UACtB,2BAA2B;UAC3B,WAAW;UACX,gBAAgB;;UAEhB;UACA;UACA,WAAW;UACX,kBAAkB;UAClB,QAAQ;UACR,wEAAwE;UACxE,UAAU;UACV;UACA;UACA,kBAAkB;UAClB,YAAY;UACZ,UAAU;;UAEV;;WAEC;WACA,eAAe;WACf,kCAAkC;WAClC,kBAAkB,MAAM,oCAAoC;;WAE5D;;WAEA;WACA,cAAc;WACd;;UAED;UACA,SAAS;UACT,mBAAmB;UACnB;;UAEA;YACE,eAAe;UACjB,gBAAgB;UAChB,iBAAiB;UACjB,kBAAkB;UAClB,eAAe;UACf,iBAAiB;UACjB,iBAAiB;UACjB,cAAc;UACd,WAAW;UACX;;UAEA;YACE,eAAe;UACjB,aAAa;UACb,mBAAmB;UACnB,WAAW;UACX,iBAAiB;UACjB,iBAAiB;UACjB;;UAEA;UACA,aAAa;UACb,WAAW;UACX,gBAAgB;UAChB,gBAAgB;UAChB,mBAAmB;UACnB;;;;UAIA;UACA,mBAAmB;UACnB,UAAU;UACV;;UAEA;UACA,UAAU;UACV,mBAAmB;UACnB,mBAAmB;UACnB,yBAAyB;UACzB;;UAEA;UACA,kBAAkB;UAClB,gBAAgB;UAChB,kBAAkB;UAClB,kBAAkB;UAClB,eAAe;UACf;;UAEA;UACA,aAAa;UACb,qCAAqC;UACrC,SAAS;UACT,qBAAqB;UACrB;UACA;UACA,eAAe;UACf,YAAY;UACZ,gBAAgB;UAChB;;UAEA;YACE,kBAAkB;UACpB,iBAAiB;UACjB,mBAAmB;UACnB,eAAe;UACf,kBAAkB;UAClB,gBAAgB;UAChB;;UAEA;UACA,aAAa;UACb,uBAAuB;UACvB,QAAQ;UACR,UAAU;UACV,gBAAgB;UAChB;;UAEA;UACA,eAAe;UACf;;;UAGA;UACA,eAAe;UACf,gBAAgB;UAChB;;;UAGA;cACI,QAAQ;UACZ,UAAU;UACV;;WAEC;WACA,uBAAuB,CAAC,QAAQ;WAChC,WAAW;WACX;;UAED;UACA,gBAAgB;UAChB;UACA;UACA,WAAW;UACX,cAAc;;UAEd;;;UAGA;aACG,gBAAgB;QACrB,mBAAmB;QACnB,kBAAkB;QAClB,kBAAkB;;UAEhB;;UAEA;UACA,aAAa;UACb,WAAW;;UAEX;;UAEA;UACA,aAAa;UACb,QAAQ;UACR,iBAAiB;UACjB,YAAY;UACZ;;UAEA;UACA,WAAW;UACX,sBAAsB;UACtB,oBAAoB;UACpB;;WAEC;;;WAGA,WAAW;WACX;;YAEC;YACA,eAAe;YACf,YAAY;YACZ;;WAED;WACA,aAAa;WACb,wBAAwB;WACxB;;WAEA;WACA,uBAAuB;WACvB,cAAc;WACd;;WAEA;WACA,WAAW;WACX,cAAc;WACd;;UAED;UACA,sBAAsB;UACtB,uBAAuB;UACvB;;UAEA;UACA,aAAa;UACb;;UAEA;UACA,cAAc;UACd,gBAAgB;UAChB,eAAe;UACf;;UAEA;UACA,mBAAmB;UACnB,gBAAgB;UAChB;;UAEA;YACE,gBAAgB;YAChB,iBAAiB;YACjB,kBAAkB;UACpB;;;UAGA;;UAEA,wBAAwB;UACxB,gBAAgB;UAChB;;;;UAIA;UACA,cAAc;UACd;;UAEA;UACA,iBAAiB;UACjB,oBAAoB;UACpB,uBAAuB;UACvB,aAAa;UACb;;UAEA;UACA,aAAa;UACb;UACA;UACA,cAAc;UACd;;UAEA;UACA,mBAAmB;;UAEnB;;UAEA;UACA,WAAW;UACX,mBAAmB;UACnB,cAAc;UACd;UACA,sDAAsD;UACtD,2CAA2C;UAC3C,sDAAsD;;UAEtD;UACA,gBAAgB;UAChB,mBAAmB;UACnB,kBAAkB;UAClB,2CAA2C;UAC3C,2BAA2B;UAC3B,aAAa;UACb,sBAAsB;UACtB,mBAAmB;UACnB,kBAAkB;UAClB,gBAAgB;UAChB,UAAU;UACV,gBAAgB;UAChB;;UAEA;UACA,cAAc;UACd,gBAAgB;UAChB,WAAW;UACX,gBAAgB;UAChB,kBAAkB;UAClB,WAAW;UACX,mBAAmB;UACnB;;;UAGA;UACA,mBAAmB;UACnB,mBAAmB;UACnB,aAAa;UACb;;uCAE6B;;UAE7B,aAAa;UACb,sBAAsB;UACtB,SAAS;UACT,gBAAgB;UAChB,mBAAmB;UACnB,WAAW;UACX;;;QAGF;UACE,qBAAqB;QACvB;;QAEA;kBACU,UAAU;cACd,mBAAmB;cACnB,kBAAkB;cAClB,oBAAoB;cACpB,gBAAgB;QACtB;;QAEA;UACE,WAAW;UACX,gBAAgB;QAClB;;;SAGC;WACE,aAAa;WACb,sBAAsB;SACxB;;SAEA;WACE,aAAa;WACb,sBAAsB;WACtB,SAAS;SACX;;SAEA;WACE,WAAW;WACX,mBAAmB;SACrB;;QAED;UACE,QAAQ;UACR,UAAU;QACZ;;QAEA,6BAA6B;QAC7B;UACE,QAAQ;cACJ,aAAa;cACb,8BAA8B;cAC9B,mBAAmB;cACnB,WAAW;cACX,oBAAoB;QAC1B;;QAEA,kBAAkB;QAClB;gBACQ,UAAU;;cAEZ,aAAa;cACb,oBAAoB;QAC1B;;QAEA,iBAAiB;QACjB;UACE,UAAU;UACV,mBAAmB;QACrB;;SAEC;mBACU,kBAAkB;cACvB,mBAAmB;cACnB,YAAY;cACZ,qCAAqC;cACrC,0BAA0B;cAC1B,cAAc;cACd,gBAAgB;cAChB,eAAe;cACf,0BAA0B;eACzB,yCAAyC;eACzC,cAAc;eACd,mBAAmB;eACnB,cAAc;OACtB;;SAEE;WACE,eAAe;WACf,QAAQ;SACV;;SAEA;WACE,wBAAwB;WACxB,cAAc;SAChB;;SAEA;WACE,sBAAsB;WACtB,uBAAuB;SACzB;;SAEA;WACE,aAAa;SACf;;SAEA;WACE,cAAc;WACd,gBAAgB;WAChB,eAAe;SACjB;;AAET;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,8DAA8D;EAC9D,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,QAAQ;EACR,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,QAAQ;EACR,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;AACA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;;;AAIA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,kCAAkC;EAClC,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;MACM,WAAW;EACf,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,mDAAmD;EACnD,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qDAAqD;AACvD;;;AAGA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;;AAGA;;EAEE;OACK,gBAAgB;IACnB,gBAAgB;IAChB,eAAe;IACf,WAAW;EACb;EACA;WACS,gBAAgB;QACnB,mBAAmB;QACnB,kBAAkB;;IAEtB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,YAAY;QACZ,0CAA0C;QAC1C,2BAA2B;QAC3B,yBAAyB;QACzB,gBAAgB;QAChB,qBAAqB;QACrB,aAAa;;MAEf;;IAEF;;QAEI,WAAW;QACX,YAAY;QACZ,eAAe;QACf,gBAAgB;IACpB;;AAEJ","sourcesContent":["\n/* ===== MOBILE VIEWPORT SAFETY ===== */\n\nhtml,\nbody {\n  width: 100%;\n  overflow-x: hidden;\n}\n\n.categoryLanding {\n  width: 100%;\n  max-width: 100%;\n  background: #f5f7fb;\n  overflow-x: hidden;\n}\n\n\n/* ===== PAGE GUTTERS ===== */\n\n\n.cl-galleryMain {\n  width: 95%;\n  max-width: 420px;\n  margin: 0 auto 16px;\n}\n\n.cl-galleryMainInner {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 4 / 3;\n  border-radius: 16px;\n  overflow: hidden;\n  background: #e5e7eb;\n}\n\n.cl-galleryMainInner img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n\n.cl-zipForm {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 10px;\n  width: 100%;\n  margin-left: 13px;\n}\n\n.cl-zipInput {\n  flex: 1;\n  padding: 5px 12px;\n    font-size: 15px;\n  border-radius: 6px;\n  border: none;\n  width: 147px;\n  \n}\n\n.cl-zipInput--manualEntry {\n  flex: 0 0 200px;\n  width: 200px;\n  max-width: 100%;\n}\n\n.cl-zipButton {\n  background: #ff9f1c;\n  color: #111;\n  font-weight: 600;\n  border: none;\n  padding: 10px 8px;\n  border-radius: 6px;\n  cursor: pointer;\n  width: 118px;\n}\n\n.cl-zipSecondaryButton {\n  background: rgba(255, 255, 255, 0.92);\n  color: #153a61;\n  font-weight: 700;\n  border: none;\n  padding: 10px 14px;\n  border-radius: 6px;\n  cursor: pointer;\n  min-width: 132px;\n}\n\nhtml[data-brand=\"house-helper\"] .categoryLanding {\n  background: #f3f8ef;\n}\n\nhtml[data-brand=\"house-helper\"] .cl-zipButton {\n  background: #f4c430;\n  color: #17351c;\n}\n\nhtml[data-brand=\"house-helper\"] .cl-zipSecondaryButton {\n  color: #1b5e20;\n}\n\nhtml[data-brand=\"house-helper\"] .cl-locationStateCard {\n  background: rgba(24, 83, 33, 0.66);\n}\n\n.cl-locationStateCard {\n  margin: 4px 14px 14px;\n  max-width: 430px;\n  padding: 18px 18px 16px;\n  border-radius: 18px;\n  background: rgba(9, 30, 66, 0.58);\n  backdrop-filter: blur(8px);\n  box-shadow: 0 14px 34px rgba(2, 20, 52, 0.28);\n}\n\n.cl-locationStateCard--fullWidth {\n  width: 100%;\n  max-width: none;\n  margin: 0;\n}\n\n.cl-locationEyebrow {\n  margin-bottom: 10px;\n  color: #ffd79a;\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.cl-locationStateTitle {\n  margin-bottom: 8px;\n  color: #ffffff;\n  font-size: 22px;\n  font-weight: 700;\n  line-height: 1.25;\n}\n\n.cl-locationStateCopy {\n  margin-bottom: 16px;\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 14px;\n  line-height: 1.55;\n}\n\n.cl-locationSpinner {\n  width: 26px;\n  height: 26px;\n  margin-bottom: 14px;\n  border-radius: 999px;\n  border: 3px solid rgba(255, 255, 255, 0.28);\n  border-top-color: #ff9f1c;\n  animation: cl-spin 0.85s linear infinite;\n}\n\n@keyframes cl-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.cl-proximityPrompt {\n  margin: 4px 0 14px 14px;\n  max-width: 360px;\n  color: #ffffff;\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 1.35;\n  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.12);\n}\n\n.cl-proximityOptions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.cl-proximityOption {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  min-height: 50px;\n  padding: 0 16px;\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.92);\n  border: 2px solid transparent;\n  box-shadow: 0 8px 20px rgba(5, 44, 84, 0.14);\n  color: #153a61;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: border-color 0.16s ease, transform 0.16s ease, box-shadow 0.16s ease;\n}\n\n.cl-proximityOption:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 12px 24px rgba(5, 44, 84, 0.18);\n}\n\n.cl-proximityOption.selected {\n  border-color: #ff9f1c;\n  box-shadow: 0 0 0 3px rgba(255, 159, 28, 0.16);\n}\n\n.cl-proximityOption input {\n  margin: 0;\n  accent-color: #ff9f1c;\n}\n\n.cl-heroDisclaimer {\n  font-size: 11px;\n  opacity: 0.8;\n  justify-self: center;\n  \n}\n\n.cl-heroTopRow,\n.cl-heroUtilityRow,\n.cl-heroMatchRow {\n  width: 100%;\n}\n\n.cl-heroTopRow {\n  display: grid;\n  grid-template-columns: minmax(0, 1.05fr) minmax(300px, 0.95fr);\n  gap: 28px;\n  align-items: start;\n}\n\n.cl-heroMediaColumn {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 14px;\n  width: 100%;\n}\n\n.cl-heroMatchRow {\n  margin-top: 14px;\n}\n\n.cl-heroRowError {\n  margin: 0 0 12px;\n}\n\n.cl-locationFooter {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  gap: 16px;\n  margin-top: 12px;\n}\n\n.cl-locationFooterSpacer {\n  min-width: 132px;\n  min-height: 44px;\n}\n\n.cl-heroDisclaimer--card {\n  margin: 10px auto 0;\n  text-align: left;\n  max-width: 100%;\n  width: auto;\n  display: block;\n  white-space: normal;\n  overflow: visible;\n  text-overflow: clip;\n  line-height: 1.45;\n}\n\n.cl-heroDisclaimer--media {\n  margin-top: 8px;\n  text-align: center;\n}\n\n.cl-heroArt {\n  order: 2;\n  display: flex;\n  align-items: flex-start;\n  padding-bottom: 0;\n  margin-top: 10px;\n}\n\n.cl-locationActionRow {\n  margin-top: 8px;\n}\n\n\n.cl-twoCol {\n  width: 766px;\n    display: grid;\n    grid-template-columns: 47.5% 52.5%;\n    margin-top: 0px;\n    justify-self: center;\n    /* max-width: 920px; */\n    /* align-items: flex-start; */\n    column-gap: 7px;\n}\n\n@media (max-width: 550px) {\n  .cl-twoCol {\n    display: block;\n  }\n}\n\n.cl-checkMark {\n  color: #22c55e;\n  font-weight: 700;\n  margin-top: 2px;\n}\n\n/* ===== CHECKLIST ALIGNMENT ===== */\n\n.cl-checkItem {\n  display: flex;\n  align-items: flex-start;\n  gap: 4px;\n}\n\n.cl-checkMark {\n  flex-shrink: 0;\n  font-size: 18px;\n  line-height: 1.4;\n  margin-top: 2px;\n  margin-left: 7px;\n}\n\n.cl-checkItem span:last-child {\n  line-height: 1.6;\n  font-weight: 500;\n  font-size: 19px;\n}\n\n.cl-featureImage {\n  height:100%;\n  width:350px;\n  border-radius: 12px;\n}\n\n/* ===== ADVANTAGES SECTION ===== */\n\n.cl-advantages {\n  background: #ffffff;\n  border-radius: 2px;\n  margin: 64px auto;\n  \n}\n\n.cl-advantages h2 {\n  font-size: 36px;\n  margin-bottom: 12px;\n}\n\n.cl-advantages p {\n  font-size: 18px;\n  color: #475569;\n  margin-bottom: 0px;\n  font-size:15px;\n}\n\n/* Cards grid */\n.cl-advantagesGrid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1px;\n}\n\n/* Individual card */\n.cl-advCard {\n  background: #f8fafc;\n  border-radius: 16px;\n  padding: 24px;\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.06);\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n}\n\n.cl-advCard:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.1);\n}\n\n.cl-advCard img {\n  width: 100%;\n  border-radius: 12px;\n  margin-bottom: 16px;\n}\n\n.cl-advCard h3 {\n  font-size: 20px;\n  margin-bottom: 8px;\n}\n\n.cl-advCard p {\n  font-size: 15px;\n  color: #475569;\n}\n\n\n/* ===== BENEFITS GRID ===== */\n\n.cl-benefits {\n  padding: 22px 0;\n  \n}\n\n.cl-benefits h2 {\n  font-size: 34px;\n  margin-bottom: 21px;\n}\n\n.cl-benefitsGrid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 32px;\n}\n\n.cl-benefitItem {\n  background: #ffffff;\n  border-radius: 18px;\n  padding: 28px;\n  box-shadow: 0 14px 32px rgba(0, 0, 0, 0.06);\n}\n\n.cl-benefitItem img {\n      justify-self: center;\n    margin-left: 10px;\n    list-style: none;\n    padding-bottom: 5px;\n    margin-left: 0px;\n    display: grid;\n    margin-right: 26px;\n    height: fit-content;\n}\n\n.cl-benefitItem h3 {\n  font-size: 20px;\n  margin-bottom: 8px;\n}\n\n.cl-benefitItem p {\n  font-size: 15px;\n  color: #475569;\n}\n\n\n\n/* ===== GALLERY ===== */\n\n.cl-gallery {\n  width: 650px;\n  background: #ffffff;\n  border-radius: 16px;\n  border: solid 1px #e2e8f0;\n}\n\n.cl-gallery h2 {\n  font-size: 19px;\n  margin-top: 10px;\n}\n\n.cl-galleryFrame {\n  border-radius: 24px;\n  padding: 0px;\n  width: 100%;\n  margin-bottom:-20px;\n}\n\n.cl-galleryFrame img {\n  border-radius: 16px;\n  max-width: 80%px;\n  max-height:200px;\n}\n\n/* ===== REVIEWS ===== */\n\n.cl-reviews {\n  padding-top: 20px;\n  \n  \n}\n\n.cl-reviews h2 {\n  font-size: 34px;\n  margin-bottom: 18px;\n}\n\n.cl-reviewCard {\n  border: solid 1px #e2e8f0;\n  background: #ffffff;\n  border-radius: 20px;\n  padding: 10px;\n  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.08);\n  text-align: center;\n  margin-bottom: 10px;\n  width: 300px;\n}\n\n.cl-reviewAvatar {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  margin: 0 auto 12px;\n  background: #e2e8f0;\n  overflow: hidden;\n  flex: 0 0 auto;\n}\n\n.cl-reviewAvatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.cl-reviewName {\n  font-weight: 600;\n  margin-bottom: 6px;\n}\n.cl-reviewGrid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 24px;\n  justify-items: center;\n  padding-top: 5px;\n}\n\n\n.cl-reviewStars {\n  color: #f59e0b;\n  margin-bottom: 12px;\n}\n\n.cl-reviewText {\n  font-size: 15px;\n  color: #475569;\n}\n/* ===== FAQ — HEADER STYLE (NOT BUTTONS) ===== */\n/* FAQ container */\n.cl-faq {\n   width: 56%;\n  max-width: 900px;\n  padding-top:25px;\n  padding-bottom:25px;\n}\n\n/* FAQ list */\n.cl-faqList {\n  border-top: 1px solid #e5e7eb;\n  width: 95%;\n}\n\n/* Each item */\n.cl-faqItem {\n  border-bottom: 1px solid #e5e7eb;\n  padding: 18px 0;\n}\n\n/* Question row — NOT a button visually */\n.cl-faqQ {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  background: none;\n  border: none;\n  padding: 0;\n\n  font-size: 15px;\n  font-weight: 600;\n  color: #111827;\n\n  cursor: pointer;\n}\n\n/* Question text */\n.cl-faqQText {\n  max-width: 90%;\n  padding-left: 8px;\n}\n\n/* Chevron */\n.cl-faqChevron {\n  width: 10px;\n  height: 10px;\n  border-right: 2px solid #6b7280;\n  border-bottom: 2px solid #6b7280;\n  transform: rotate(45deg);\n  transition: transform 0.2s ease;\n}\n\n/* Open state */\n.cl-faqItem.isOpen .cl-faqChevron {\n  transform: rotate(-135deg);\n}\n\n/* Answer */\n.cl-faqA {\n  margin: 4px;\n  font-size: 15px;\n  line-height: 1.6;\n  color: #374151;\n  max-width: 720px;\n  padding-left: 5px;\n}\n\n/* Focus styles for accessibility */\n.cl-faqQ:focus {\n  outline: none;\n}\n\n.cl-faqQ:focus-visible {\n  outline: 2px solid #2563eb;\n  outline-offset: 4px;\n}\n\nhtml[data-brand=\"house-helper\"] .cl-faqQ:focus-visible {\n  outline-color: #2f7d32;\n}\n\nhtml[data-brand=\"house-helper\"] .featured-tool-box {\n  border-color: rgba(124, 194, 67, 0.5);\n}\n\n\n\n\n/* ================================\n   SKELETON LOADERS\n================================ */\n\n@keyframes skeletonPulse {\n  0% {\n    background-position: -200px 0;\n  }\n  100% {\n    background-position: calc(200px + 100%) 0;\n  }\n}\n\n.cl-skeleton {\n  background: linear-gradient(\n    90deg,\n    #e5e7eb 25%,\n    #f3f4f6 37%,\n    #e5e7eb 63%\n  );\n  background-size: 400px 100%;\n  animation: skeletonPulse 1.4s ease infinite;\n  border-radius: 12px;\n}\n\n/* ===== GALLERY SKELETON ===== */\n\n.cl-gallerySkeleton {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 24px;\n}\n\n.cl-gallerySkeletonItem {\n  aspect-ratio: 4 / 3;\n  border-radius: 16px;\n}\n\n\n/* ===== REVIEWS SKELETON ===== */\n\n.cl-reviewSkeleton {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 28px;\n}\n\n.cl-reviewSkeletonCard {\n  background: #ffffff;\n  border-radius: 20px;\n  padding: 28px;\n}\n\n.cl-reviewSkeletonAvatar {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  margin: 0 auto 14px;\n}\n\n.cl-reviewSkeletonLine {\n  height: 14px;\n  border-radius: 6px;\n  margin-bottom: 10px;\n}\n\n.cl-reviewSkeletonLine.short {\n  width: 60%;\n  margin: 10px auto 0;\n}\n\n.cl-galleryThumbs {\n  display: flex;\n  gap: 12px;\n  overflow-x: auto;\n    max-width: 102%;\n  overflow-x: auto;\n  justify-content: center;\n  margin-bottom: 25px;\n}\n\n.cl-galleryThumb {\n  border: none;\n  background: none;\n  padding: 0;\n  cursor: pointer;\n  opacity: 0.6;\n}\n\n.cl-galleryThumb.isActive {\n  opacity: 1;\n  outline: 2px solid #6366f1;\n  border-radius: 8px;\n}\n\n.cl-galleryThumb img {\n  height: 64px;\n  width: auto;\n  border-radius: 8px;\n  display: block;\n}\n\n\n\n\n/* ===== MOBILE IMAGE CONSTRAINTS ===== */\n\n\n\n\n.cl-cardImg {\n    max-width: 300px;\n    padding:15px;\n}\n.cl-container {\n  width: 100%;\n  max-width: 800px;\n  text-align: left;\n  padding-right: 5px;\n  padding-left: 5px;\n  height:auto;\n  padding-top: 0px;\n  justify-items: center;\n    \n}\n/* ===== ZIP VALIDATION ERROR ===== */\n\n/* ===== ZIP VALIDATION (BRIGHT YELLOW) ===== */\n\n.cl-zipError {\n  color: #fde047; /* yellow-300 */\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 8px;\n  height: 12px;\n  padding-left: 35px;\n}\n\n.cl-zipRow {\n  width: 90%;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n}\n\n.cl-zipRow--stackMobile {\n  width: 100%;\n}\n\n.cl-zipInput[aria-invalid=\"true\"] {\n  border: 2px solid #facc15; /* yellow-400 */\n  box-shadow: 0 0 0 2px rgba(250, 204, 21, 0.35);\n}\n\n\n\n.cl-breadcrumbRow {\n    padding-top: 10px;\n    padding-bottom: 5px;\n    font-size: 10pt;\n    padding-left: 10px;\n    font-weight: 600;\n}\n\n.cl-section {\n    vertical-align: top;\n    \n}\n.cl-body{\n    font-size: 16px;\n    color: #475569;\n    margin: 7px 9px -8px 18px;\n    text-align: center;\n}\n .cl-h2 {\n    margin-bottom: 7px;\n    font-weight: 700;\n    text-align: center;\n    font-size:23px;\n  }\n\n\n\n\n/* =========================================\n   TABLET AND DESKTOP — REMOVE HERO CLIPPING\n========================================= */\n@media (min-width: 550px) {\n\n\n      .featuredContractorCard-OLD {\n        \n        \n        \n        padding-bottom: 5px;\n        box-shadow: 0 2px 10px rgba(0,0,0,0.08);\n        margin-top: 10px !important;\n        max-width: 63% !important;\n        justify-self: center;\n      }\n\n      .cl-proximityPrompt {\n        max-width: 420px;\n      }\n\n      .featuredContractorCard {\n                background: #fff;\n        padding: 3px 8px;\n        border-radius: 12px;\n        position: relative;\n        z-index: 5;\n        margin-top: 15px !important;\n        max-width: 722px !important;\n        width: 100%;\n        justify-self: center;\n        margin-left: auto;\n        margin-right: auto;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: 16px;\n      }\n\n      .featuredContractorInner {\n        display: flex;\n        gap: 12px;\n        align-items: center;\n        margin-top: -4px;\n        width: 100%;\n      }\n\n      .featuredContractorImage {\n        flex-shrink: 0;\n        max-width: 180px;\n      }\n\n      .featuredContractorImage img {\n                display: block;\n        height: 120px;/*  */\n        width: auto;\n        border-radius: 8px;\n        /* object-fit: cover; */\n        max-width: 159px;\n      }\n\n      .featuredContractorContent {\n        flex: 1;\n      }\n\n      .featuredContractorContent h3 {\n        font-size: 14px;\n        color: #6b7280;\n        margin-bottom: 4px;\n      }\n\n      .featuredContractorContent h2 {\n        font-size: 18px;\n        margin: 0;\n      }\n\n      .featuredContractorContent p {\n        font-size: 14px;\n        margin: 6px 0 10px;\n      }\n\n      .primaryButton {\n        background: #f59e0b;\n        border: none;\n        padding: 8px 14px;\n        border-radius: 6px;\n        cursor: pointer;\n        font-weight: 600;\n      }\n\n      .featuredContractorButton {\n        margin-left: auto;\n        white-space: nowrap;\n      }\n\n  .cl-h2-b {\n       font-weight: 700;\n    text-align: left;\n    font-size: 23px;\n    width: 106%;\n  }\n\n  .heroModalContent {\n            /* width: 50%; */\n        max-width: 650px;\n        justify-self: center;\n        margin-top: 95px;\n  }\n\n.cl-benefitBody {\n  font-size: 15px;\n  line-height: 1.6;\n  color: #475569;\n  width: 476px;\n}\n\n\n.cl-benefitGrid {\n  display: grid;\n  justify-self: center;\n  gap: 20px;\n  margin-left: 15px;\n  margin-right: 15px;\n}\n\n.cl-benefit {\n  display: grid;\n  grid-template-columns: 20px 1fr;\n  column-gap: 12px;\n  align-items: start;\n  margin-top: 5px;\n}\n\n.cl-benefitIcon {\n  font-size: 23px;\n}\n\n.cl-benefitText {\n  display: block;\n}\n\n.cl-benefitTitle {\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n\n.cl-helpButtonContainer {\n\t       justify-self: center;\n\t    padding: 10px 20px;\n        border-radius: 40px;\n        border: none;\n        background: rgba(255, 255, 255, 0.18);\n        backdrop-filter: blur(8px);\n        color: #ffffff;\n        font-weight: 600;\n        cursor: pointer;\n        transition: all 0.25s ease;\n\t    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.2);\n\t    /* display: block; */\n\t    margin-bottom: 10px;\n\t    margin-left: 0;\n\t            width: 100%;\n      max-width: 300px;\n}\n\n/* ================================================= */\n/* FEATURED TOOL BOX (GENERIC CARD STYLE) */\n/* ================================================= */\n\n        .featured-tool-box {\n          background: #fff;\n        border-radius: 16px;\n        padding: 12px 24px 2px 24px;\n        box-shadow: 0 12px 24px rgba(0, 0, 0, 0.08);\n        border: 1px solid #3690ffa2;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        text-align: center;\n        /* max-width: 720px; */\n        width: 96%;\n        justify-self: center;\n        margin-top: 15px;;\n        }\n\n\t        .cl-heroGrid {\n\t        width: 780px;\n\t        text-align: left;\n\t        display: flex;\n\t        flex-direction: column;\n\t        }\n\n        .cl-heroCopy{\n        order: 1;\n        width: 67%;\n        }\n        .foundation-bubbles-grid {\n        display: grid;\n        grid-template-columns: repeat(3, 1fr);\n        gap: 17px;\n\n        }\n        .cl-heroImg{  \n        width: 99%;\n        height: auto;\n        margin-top: 10px;\n        margin-bottom: 10px;\n        border-radius: 14px;\n        margin-right: 62px;\n        margin-left: 10px;\n        }\n\n        .cl-benefits {\n        padding: 22px 21px;\n        width: 70%;\n        }\n\n        .foundation-card {\n        background: #ffffff;\n        border-radius: 20px;\n        padding: 13px;\n        box-shadow:\n        0 6px 18px rgba(0, 0, 0, 0.06),\n        0 1px 2px rgba(0, 0, 0, 0.04);\n\n        display: flex;\n        flex-direction: column;\n        gap: 14px;\n        margin-top: 20px;\n        margin-bottom: 20px;\n        width: 100%;\n        }\n\n        .cl-checkList {\n        list-style: none;\n        padding-bottom: 5px;\n        }\n\n   \n\n\n\n        .cl-hero {\n        padding-bottom: 10px;\n        justify-content: center;\n        display: flex;\n        }\n\n        .cl-heroArt {\n        display: block;\n        order: 2;\n        }\n\n\n        .cl-featureImageWrap {\n        border-radius: 10px;\n        padding: 4px;\n\n\n        } \n\n        .cl-advantagesGrid {\n        grid-template-columns: 1fr;\n        }\n\n        .cl-advantages {\n        border-radius: 0;\n        margin: 0;\n        }\n\n        .cl-benefitsGrid {\n        grid-template-columns: 1fr;\n        }\n        .cl-gallerySkeleton {\n        grid-template-columns: 1fr;\n        }\n        .cl-reviewSkeleton {\n        grid-template-columns: 1fr;\n        }\n\n\n        .cl-zipForm {\n        display: flex;\n        margin-bottom: 10px;\n        width: 100%;\n        margin-left: 15px;\n\n        }\n        .cl-zipButton {\n        background: #ff9f1c;\n        color: #111;\n        font-weight: 600;\n        border: none;\n        padding: 10px 8px;\n        border-radius: 6px;\n        cursor: pointer;\n        width: 117px;\n        margin-left: 10px;\n        }\n\n}\n.cl-showDesktop {\n    align-content: center;\n    min-height: 345px;\n    padding-top: 15px\n  }\n\n.cl-showMobile {\n  display: none;\n}\n\n.cl-hero {\n  position: relative;\n  background-size: cover;\n  background-position: center;\n  color: #fff;\n  padding-top: 5px;\n  \n}\n.cl-hero::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(135deg, #79b7f2 0%, rgba(29, 180, 255, 0.9));\n  z-index: 0;\n}\n\nhtml[data-brand=\"house-helper\"] .cl-hero::before {\n  background:\n    radial-gradient(820px 420px at 14% 28%, rgba(255, 255, 255, 0.22), transparent 58%),\n    linear-gradient(135deg, #7cc243 0%, rgba(47, 125, 50, 0.94));\n}\n.cl-heroInner {\n  position: relative;\n  display:flex;\n  z-index: 1;\n  \n}\n\n\n.cl-heroTitle {\n  font-size: 23px;\n    font-weight: 700;\n    line-height: 1.15;\n    margin-bottom: 8px;\n    margin-top: 11px;\n    margin-left: 6px;\n    /* margin-right: 15px; */\n    color: #005cac;\n}\n\nhtml[data-brand=\"house-helper\"] .cl-heroTitle {\n  color: #1b5e20;\n}\n\n.cl-heroSubtitle {\n  font-size: 18px;\n  opacity: 0.95;\n  margin-bottom: 10px;\n  margin-left: 10px;\n  margin-right: 15px;\n}\n\n\n.featuredToolBand {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n\n  /* Visually separate from text column */\n  \n}\n.cl-cardGrid {\n  \n  padding-bottom: 20px;\n  \n} \n.toolsGrid {\n  padding: 0px 0;\n}\n.foundation-bubbles {\n    padding-top: 25px;\n    width: 96%;\n    max-width: 800px;\n    text-align: center;\n    padding-right: 10px;\n    padding-left: 13px;\n    height: auto;\n    justify-items: center;\n}\n\n\n\n.foundation-item {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.bubble {\n  background: #ffffff;\n  border-radius: 18px;\n  padding: 16px;\n  box-shadow:\n    0 6px 18px rgba(0, 0, 0, 0.06),\n    0 1px 2px rgba(0, 0, 0, 0.04);\n}\n.bubble-image {\n  padding: 0;\n  overflow: hidden;\n}\n\n.bubble-image img {\n  width: 100%;\n  height: 180px;\n  object-fit: cover;\n  display: block;\n  border-radius: 18px;\n}\n\n.bubble-title h3 {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: #1f2937;\n}\n\n.bubble-subtitle p {\n  margin: 0;\n  font-size: 0.95rem;\n  line-height: 1.5;\n  color: #4b5563;\n}\n\n\n/* Mobile */\n@media (max-width: 550px) {\n\n\n        .featuredContractorCard {\n          background: #fff;\n          border-radius: 12px;\n          padding: 10px 12px;\n          box-shadow: 0 2px 10px rgba(0,0,0,0.08);\n          margin-top: 20px !important;\n          justify-self: center !important;\n          margin-left: 0px;\n          max-width: 94% !important;\n          width: calc(100% - 12px);\n        }\n\n        .featuredContractorInner {\n          display: flex;\n          gap: 10px;\n          align-items: center;\n          width: 100%;\n        }\n\n        .featuredContractorImage {\n          width: 56px;\n          height: 56px;\n          flex: 0 0 56px;\n          flex-shrink: 0;\n        }\n\n        .featuredContractorImage img {\n          width: 56px;\n          height: 56px;\n          max-width: 56px;\n          max-height: 56px;\n          border-radius: 12px;\n          object-fit: cover;\n          object-position: center;\n          display: block;\n        }\n\n        .featuredContractorContent  {\n          flex: 1 1 auto;\n          min-width: 0;\n          margin-top: 0;\n        }\n\n        .featuredContractorContent h3 {\n          font-size: 11px;\n          color: #6b7280;\n          margin-bottom: 3px;\n          margin-top: 0px;\n        }\n\n        .featuredContractorContent h2 {\n          font-size: 16px;\n          margin: 0;\n          text-align: left;\n          line-height: 1.15;\n        }\n\n        .featuredContractorContent p {\n          font-size: 12px;\n          line-height: 1.35;\n          margin: 4px 0 0;\n        }\n\n        .primaryButton {\n          background: #f59e0b;\n          border: none;\n          padding: 8px 14px;\n          border-radius: 6px;\n          cursor: pointer;\n          font-weight: 600;\n          margin-bottom: 10px;\n        }\n\n        .featuredContractorButton {\n          margin-left: 0;\n          flex: 0 0 auto;\n          align-self: center;\n          min-width: 96px;\n          padding: 10px 12px;\n          white-space: nowrap;\n        }\n\n\n          .cl-h2-b {\n             margin-bottom: 7px;\n        margin-top: -36px;\n        font-weight: 700;\n        text-align: left;\n        font-size: 24px;\n        margin-left: 4px;\n        max-width: 110%;\n          }\n\n          .cl-benefitBody {\n          font-size: 15px;\n          line-height: 1.6;\n          color: #475569;\n          }\n\n\n          .cl-benefitGrid {\n          display: grid;\n          gap: 20px;\n          margin-left: 15px;\n          margin-right: 15px;\n          }\n\n          .cl-benefit {\n          display: grid;\n          grid-template-columns: 21px 1fr;\n          column-gap: 6px;\n          align-items: start;\n          margin-top: 5px;\n          }\n\n          .cl-benefitIcon {\n          font-size: 23px;\n          }\n\n          .cl-benefitText {\n          display: block;\n          }\n\n          .cl-benefitTitle {\n          font-size: 18px;\n          font-weight: 600;\n          margin-bottom: 4px;\n          }\n\n\n          .cl-hero {\n          position: relative;\n          background-size: cover;\n          background-position: center;\n          color: #fff;\n          padding-top: 5px;\n\n          }\n          .cl-hero::before {\n          content: \"\";\n          position: absolute;\n          inset: 0;\n          background: linear-gradient(135deg, #79b7f2 0%, rgba(29, 180, 255, 0.9));\n          z-index: 0;\n          }\n          .cl-heroInner {\n          position: relative;\n          display:flex;\n          z-index: 1;\n\n          }\n\n\t          .cl-heroGrid {\n\t          display: inline;\n\t          grid-template-columns: 1.1fr 0.9fr;\n\t          align-items: start;     /* 🔑 prevents vertical stretching */\n\n\t          }\n\n\t          .cl-heroTopRow {\n\t          display: block;\n\t          }\n\n          .cl-heroMediaColumn {\n          gap: 10px;\n          align-items: center;\n          }\n\n          .cl-heroTitle {\n            font-size: 23px;\n          font-weight: 700;\n          line-height: 1.15;\n          margin-bottom: 8px;\n          margin-top: 9px;\n          margin-left: 11px;\n          margin-right: 5px;\n          color: #005cac;\n          width: 100%;\n          }\n\n          .cl-heroSubtitle {\n            font-size: 18px;\n          opacity: 0.95;\n          margin-bottom: 10px;\n          width: 100%;\n          margin-left: 12px;\n          margin-right: 5px;\n          }\n\n          .cl-faq {\n          margin: 14px ;\n          width: 100%;\n          max-width: 900px;\n          padding-top:25px;\n          padding-bottom:25px;\n          }\n\n\n\n          .cl-heroArt img {\n          border-radius: 14px;\n          width: 90%;\n          }\n\n          .cl-gallery {\n          width: 94%;\n          background: #ffffff;\n          border-radius: 16px;\n          border: solid 1px #e2e8f0;\n          }\n\n          .cl-h2 {\n          margin-bottom: 7px;\n          font-weight: 700;\n          padding-left: 18px;\n          padding-right: 5px;\n          font-size: 19px;\n          }\n\n          .cl-reviewGrid {\n          display: grid;\n          grid-template-columns: repeat(1, 1fr);\n          gap: 24px;\n          justify-items: center;\n          }\n          .cl-heroDisclaimer {\n          font-size: 11px;\n          opacity: 0.8;\n          margin-left: 8px;\n          }\n\n          .cl-breadcrumbRow {\n            line-height: 0.1em;\n          padding-top: 10px;\n          padding-bottom: 5px;\n          font-size: 10pt;\n          padding-left: 10px;\n          font-weight: 600;\n          }\n\n          .cl-checkItem {\n          display: flex;\n          align-items: flex-start;\n          gap: 6px;\n          width: 98%;\n          font-weight: 500;\n          }\n\n          .cl-checkItem span:last-child {\n          font-size: 17px;\n          }\n\n\n          .cl-gallery h2 {\n          font-size: 20px;\n          margin-top: 12px;\n          }\n\n\n          .cl-heroCopy {\n              order: 1;\n          width: 94%;\n          }\n\n\t          .cl-heroArt {\n\t          justify-content: center;order: 2;\n\t          width: 100%;\n\t          }\n\n          .cl-galleryFrame img {\n          max-height:200px;\n          }\n          .cl-twoCol {\n          width: 100%;\n          display: block;\n\n          }\n\n\n          .cl-checkList {\n             list-style: none;\n        padding-bottom: 5px;\n        margin-left: -28px;\n        margin-right: 10px;\n\n          }\n\n          .cl-zipForm {\n          display: flex;\n          width: 100%;\n\n          }\n\n          .cl-zipRow {\n          display: flex;\n          gap: 7px;\n          align-items: left;   \n          width: 276px;\n          }\n\n          .cl-zipRow--stackMobile {\n          width: 100%;\n          flex-direction: column;\n          align-items: stretch;\n          }\n\n\t          .cl-zipInput,\n\t          .cl-zipButton,\n\t          .cl-zipSecondaryButton {\n\t          width: 100%;\n\t          }\n\n            .cl-zipInput--manualEntry {\n            flex: 0 0 200px;\n            width: 200px;\n            }\n\n\t          .cl-locationStateCard--fullWidth {\n\t          margin: 0 8px;\n\t          width: calc(100% - 16px);\n\t          }\n\n\t          .cl-heroUtilityInner {\n\t          align-items: flex-start;\n\t          padding: 0 8px;\n\t          }\n\n\t          .cl-helpButtonContainer {\n\t          width: auto;\n\t          margin-left: 0;\n\t          }\n\n          .cl-locationFooter {\n          flex-direction: column;\n          align-items: flex-start;\n          }\n\n          .cl-locationFooterSpacer {\n          display: none;\n          }\n\n          .cl-heroDisclaimer--card {\n          margin-left: 0;\n          text-align: left;\n          max-width: none;\n          }\n\n          .cl-galleryFrame {\n          aspect-ratio: 4 / 3;\n          overflow: hidden;\n          }\n\n          .cl-h2 {\n            font-weight: 700;\n            padding-left: 0px;\n            text-align: center;\n          }\n\n\n          .cl-advantages,\n          .cl-reviews  {\n          margin: 14px auto 0 auto;\n          max-width: 900px;\n          }\n\n\n\n          .cl-valueProps .cl-featureImage {\n          display: block;\n          }\n\n          .cl-valueProps {\n          min-height: 324px;\n          padding-bottom: 10px;\n          justify-content: center;\n          display: flex;\n          }\n\n          .cl-showDesktop {\n          display: none;\n          }\n          .cl-showMobile {\n          display: block;\n          }\n\n          .cl-featureImageWrap {\n          border-radius: 10px;\n\n          } \n\n          .cl-featureImage {\n          width: 100%;\n          border-radius: 12px;\n          display: block;\n          }\n          /* ================================================= */\n          /* FEATURED TOOL BOX (GENERIC CARD STYLE) */\n          /* ================================================= */\n\n          .featured-tool-box {\n          background: #fff;\n          border-radius: 16px;\n          padding: 19px 12px;\n          box-shadow: 0 12px 24px rgba(0, 0, 0, 0.08);\n          border: 1px solid #3690ffa2;\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          text-align: center;\n          max-width: 720px;\n          width: 89%;\n          margin: 8px auto;\n          }\n\n          .foundation-bubbles {\n          display: block;\n          padding-top:25px;\n          width: 100%;\n          max-width: 800px;\n          text-align: center;\n          height:auto;\n          justify-items: self;\n          }\n\n\n          .foundation-card {\n          background: #ffffff;\n          border-radius: 20px;\n          padding: 13px;\n          box-shadow:\n          0 6px 18px rgba(0, 0, 0, 0.06),\n          0 1px 2px rgba(0, 0, 0, 0.04);\n\n          display: flex;\n          flex-direction: column;\n          gap: 14px;\n          margin-top: 20px;\n          margin-bottom: 20px;\n          width: 100%;\n          }\n\n\n        .heroModalOverlay {\n          align-items: flex-end;\n        }\n\n        .heroModalContent {\n                  width: 85%;\n              border-radius: 24px;\n              padding: 10px 11px;\n              justify-self: center;\n              margin-top: 25px;\n        }\n\n        .heroHelpButton {\n          width: 100%;\n          margin-top: 16px;\n        }\n        \n\n\t        .cl-heroGrid {\n\t          display: flex;\n\t          flex-direction: column;\n\t        }\n\n\t        .cl-heroTopRow {\n\t          display: flex;\n\t          flex-direction: column;\n\t          gap: 12px;\n\t        }\n\n\t        .cl-heroMediaColumn {\n\t          width: 100%;\n\t          align-items: center;\n\t        }\n\n        .cl-heroCopy {\n          order: 1;\n          width: 94%;\n        }\n\n        /* Container becomes column */\n        .cl-heroArt {\n          order: 2;\n              display: flex;\n              flex-direction: column-reverse;\n              align-items: center;\n              width: 100%;\n              justify-self: center;\n        }\n\n        /* Button styles */\n        .heroHelpButton {\n                width: 69%;\n              \n              display: flex;\n              justify-self: center;\n        }\n\n        /* Image styles */\n        .cl-heroArt img {\n          width: 90%;\n          border-radius: 14px;\n        }\n\n\t        .cl-helpButtonContainer {\n\t                  padding: 10px 20px;\n              border-radius: 40px;\n              border: none;\n              background: rgba(255, 255, 255, 0.18);\n              backdrop-filter: blur(8px);\n              color: #ffffff;\n              font-weight: 600;\n              cursor: pointer;\n              transition: all 0.25s ease;\n\t              box-shadow: 0 6px 18px rgba(0, 0, 0, 0.2);\n\t              display: block;\n\t              margin-bottom: 10px;\n\t              margin-left: 0;\n\t      }\n\n\t        .cl-heroUtilityInner {\n\t          padding: 0 13px;\n\t          gap: 8px;\n\t        }\n\n\t        .cl-locationStateCard--fullWidth {\n\t          width: calc(100% - 26px);\n\t          margin: 0 13px;\n\t        }\n\n\t        .cl-locationFooter {\n\t          flex-direction: column;\n\t          align-items: flex-start;\n\t        }\n\n\t        .cl-locationFooterSpacer {\n\t          display: none;\n\t        }\n\n\t        .cl-heroDisclaimer--card {\n\t          margin-left: 0;\n\t          text-align: left;\n\t          max-width: none;\n\t        }\n\n}\n\n.foundation-card-image {\n  width: 100%;\n  height: 180px;\n  object-fit: cover;\n  border-radius: 16px;\n}\n\n/* Hero layout overrides */\n.cl-heroTopRow {\n  display: grid;\n  grid-template-columns: minmax(0, 1.05fr) minmax(320px, 0.95fr);\n  gap: 28px;\n  align-items: start;\n}\n\n.cl-heroCopyColumn {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  min-width: 0;\n}\n\n.cl-heroCopy {\n  order: 1;\n  width: 100%;\n}\n\n.cl-heroMediaColumn {\n  order: 2;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 14px;\n  width: 100%;\n}\n\n.cl-heroMediaColumn .cl-heroArt {\n  order: 1;\n  width: 100%;\n  justify-content: flex-end;\n  margin-top: 0;\n}\n\n.cl-heroInlineCard {\n  order: 2;\n  width: 100%;\n  max-width: 590px;\n}\n\n.cl-heroInlineCard .cl-locationStateCard--fullWidth {\n  width: 100%;\n  max-width: none;\n}\n\n.cl-heroInlineCard .cl-locationStateCard {\n  margin: 0;\n  padding: 14px 16px 12px;\n}\n\n.cl-heroInlineCard .cl-proximityPrompt {\n  margin: 2px 0 10px;\n  max-width: none;\n  font-size: 18px;\n  line-height: 1.25;\n}\n\n.cl-heroInlineCard .cl-locationEyebrow {\n  margin-bottom: 6px;\n}\n\n.cl-heroInlineCard .cl-locationStateCopy {\n  margin-bottom: 12px;\n  font-size: 13px;\n  line-height: 1.45;\n}\n\n.cl-heroInlineCard .cl-zipForm {\n  margin-left: 0;\n  margin-bottom: 6px;\n}\n\n.cl-heroInlineCard .cl-zipRow {\n  gap: 10px;\n  align-items: center;\n}\n\n.cl-heroInlineCard .cl-proximityOptions {\n  margin-bottom: 0;\n}\n\n.cl-helpButtonContainer--media {\n  order: 2;\n  width: 100%;\n  max-width: 300px;\n  align-self: center;\n  margin: 0 auto;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  visibility: visible;\n  opacity: 1;\n}\n\n.cl-heroMediaColumn .cl-heroDisclaimer--media {\n  order: 3;\n  width: 100%;\n  align-self: center;\n}\n\n@media (max-width: 900px) {\n  .cl-heroTopRow {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .cl-heroMediaColumn {\n    align-items: center;\n  }\n\n  .cl-heroMediaColumn .cl-heroArt {\n    justify-content: center;\n  }\n\n  .cl-heroInlineCard {\n    max-width: none;\n  }\n\n  .cl-helpButtonContainer--media {\n    width: 100%;\n    max-width: 320px;\n  }\n}\n.foundation-card-title {\n  \n  text-align: center;\n}\n\n.foundation-card-body {\n  margin: 0;\n  margin-top: -19px;\n  margin-left: 0px;\n  line-height: 1.3em;\n}\n\n\n\n.heroHelpButton {\n  margin-top: 18px;\n  padding: 12px 22px;\n  border-radius: 40px;\n  border: none;\n  background: rgba(255,255,255,0.18);\n  backdrop-filter: blur(10px);\n  color: #fff;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.25s ease;\n  box-shadow: 0 6px 18px rgba(0,0,0,0.2);\n}\n\n.heroHelpButton:hover {\n  background: rgba(255,255,255,0.28);\n  transform: translateY(-2px);\n}\n\n.heroModalOverlay {\n      width: 100%;\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.55);\n  z-index: 9999;\n}\n\n.heroModalContent {\n  margin: 20px;\n  max-height: 90vh;\n  max-width: 95vh;\n  overflow-y: auto;\n  justify-self: center;\n  background: #fff;\n  padding: 15px;\n  border-radius: 24px;\n  box-shadow: 0 20px 60px rgba(0,0,0,0.25);\n  text-align: center;\n  animation: fadeInScale 0.2s ease forwards;\n}\n\n.heroModalContent h3 {\n  margin-bottom: 10px;\n  margin-top: 0px;\n  color: #0075cfd9;\n}\n\n.heroModalContent p {\n  margin-top: 4px;\n  line-height: 1.3;\n  color: #333;\n}\n\n.heroModalClose {\n  margin-top: 4px;\n  padding: 12px 26px;\n  border-radius: 30px;\n  border: none;\n  background: linear-gradient(135deg,#0075cf,#004fa3);\n  color: #fff;\n  font-weight: 600;\n  cursor: pointer;\n}\n\nhtml[data-brand=\"house-helper\"] .heroModalContent h3 {\n  color: #2f7d32;\n}\n\nhtml[data-brand=\"house-helper\"] .heroModalClose {\n  background: linear-gradient(135deg, #7cc243, #2f7d32);\n}\n\n\n@keyframes fadeInScale {\n  from {\n    opacity: 0;\n    transform: scale(0.96);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n\n@media (max-width: 320px) {\n\n  .cl-h2-b {\n       font-weight: 700;\n    text-align: left;\n    font-size: 17px;\n    width: 106%;\n  }\n  .cl-checkList {\n           list-style: none;\n        padding-bottom: 5px;\n        margin-left: -26px;\n\n    }\n\n    .featuredContractorCard {\n        background: #fff;\n        border-radius: 12px;\n        padding: 6px;\n        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);\n        margin-top: 20px !important;\n        max-width: 91% !important;\n        margin-left: 7px;\n        justify-content: left;\n        display: flex;\n        \n      }\n\n    .featuredContractorImage,\n    .featuredContractorImage img {\n        width: 48px;\n        height: 48px;\n        max-width: 48px;\n        max-height: 48px;\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
